import { truncateUtf8Bytes } from '@deltasierra/utilities-string';

const illegalRe = /[^a-zA-Z0-9-]/g;

/**
 * Replaces characters in strings that are illegal/unsafe for components in routes.
 * Unsafe characters are either removed or replaced by a substitute set
 * in the optional `options` object.
 *
 * The only allowed characters are 'a-z', 'A-Z', '0-9' and '-'.
 *
 * Capped at 255 characters in length.
 * http://unix.stackexchange.com/questions/32795/what-is-the-maximum-allowed-filename-and-folder-size-with-ecryptfs
 *
 * This code was based on and altered from:
 *
 * @see https://github.com/parshap/node-sanitize-filename
 * @param input - The original route path
 * @param replacement - The replacement string @default '_'
 * @returns - Sanitized route path
 */
export function sanitizeRouteComponent(input: string, replacement = '_'): string {
    if (typeof input !== 'string') {
        throw new Error('Input must be string');
    }
    const sanitized = input.replace(illegalRe, replacement);
    return truncateUtf8Bytes(sanitized, 255);
}
